// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as UsernameRouteImport } from './routes/$username'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as AlternativaAoDiscogsRouteImport } from './routes/alternativa-ao-discogs'
import { Route as AssinarRouteImport } from './routes/assinar'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as ChatRouteImport } from './routes/chat'
import { Route as ColecionadoresRouteImport } from './routes/colecionadores'
import { Route as CollectionRouteImport } from './routes/collection'
import { Route as ComunidadeRouteImport } from './routes/comunidade'
import { Route as ConquistasRouteImport } from './routes/conquistas'
import { Route as ContatoRouteImport } from './routes/contato'
import { Route as ConvidarRouteImport } from './routes/convidar'
import { Route as ExploreRouteImport } from './routes/explore'
import { Route as FeedRouteImport } from './routes/feed'
import { Route as GarimpoRouteImport } from './routes/garimpo'
import { Route as InsightsRouteImport } from './routes/insights'
import { Route as LabRouteImport } from './routes/lab'
import { Route as LevelsRouteImport } from './routes/levels'
import { Route as MarketplaceRouteImport } from './routes/marketplace'
import { Route as MeRouteImport } from './routes/me'
import { Route as MiniSiteRouteImport } from './routes/mini-site'
import { Route as PoliticaDeReembolsoRouteImport } from './routes/politica-de-reembolso'
import { Route as PrivacidadeRouteImport } from './routes/privacidade'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as RitualRouteImport } from './routes/ritual'
import { Route as SearchRouteImport } from './routes/search'
import { Route as SemanalRouteImport } from './routes/semanal'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as SobreNosRouteImport } from './routes/sobre-nos'
import { Route as StreaksRouteImport } from './routes/streaks'
import { Route as TermosDeServicoRouteImport } from './routes/termos-de-servico'
import { Route as UnsubscribeRouteImport } from './routes/unsubscribe'
import { Route as WishlistRouteImport } from './routes/wishlist'
import { Route as AuthenticatedOnboardingRouteImport } from './routes/_authenticated/onboarding'
import { Route as AlbumIdRouteImport } from './routes/album.$id'
import { Route as ArtistasIndexRouteImport } from './routes/artistas.index'
import { Route as ArtistasSlugRouteImport } from './routes/artistas.$slug'
import { Route as BlogIndexRouteImport } from './routes/blog.index'
import { Route as BlogSlugRouteImport } from './routes/blog.$slug'
import { Route as ComunidadesIndexRouteImport } from './routes/comunidades.index'
import { Route as ComunidadesNovoRouteImport } from './routes/comunidades.novo'
import { Route as DiscosDeVinilIndexRouteImport } from './routes/discos-de-vinil.index'
import { Route as DiscosDeVinilSlugRouteImport } from './routes/discos-de-vinil.$slug'
import { Route as GruposIndexRouteImport } from './routes/grupos.index'
import { Route as GruposSplatRouteImport } from './routes/grupos.$'
import { Route as GuiasIndexRouteImport } from './routes/guias.index'
import { Route as GuiasSlugRouteImport } from './routes/guias.$slug'
import { Route as LabIndexRouteImport } from './routes/lab.index'
import { Route as LabIdRouteImport } from './routes/lab.$id'
import { Route as LabRoadmapRouteImport } from './routes/lab.roadmap'
import { Route as MiniSiteIndexRouteImport } from './routes/mini-site.index'
import { Route as PCodeRouteImport } from './routes/p.$code'
import { Route as ProductsSplatRouteImport } from './routes/products.$'
import { Route as ProfileUsernameRouteImport } from './routes/profile.$username'
import { Route as SettingsIndexRouteImport } from './routes/settings.index'
import { Route as SettingsAccountRouteImport } from './routes/settings.account'
import { Route as SettingsBillingRouteImport } from './routes/settings.billing'
import { Route as SettingsNotificationsRouteImport } from './routes/settings.notifications'
import { Route as SettingsPerformanceRouteImport } from './routes/settings.performance'
import { Route as SettingsProfileRouteImport } from './routes/settings.profile'
import { Route as DotlovableOauthConsentRouteImport } from './routes/[.]lovable.oauth.consent'
import { Route as AuthenticatedAdminBlogRouteImport } from './routes/_authenticated/admin.blog'
import { Route as AuthenticatedAdminCrmRouteImport } from './routes/_authenticated/admin.crm'
import { Route as AuthenticatedAdminEmailsRouteImport } from './routes/_authenticated/admin.emails'
import { Route as ComunidadesSlugIndexRouteImport } from './routes/comunidades.$slug.index'
import { Route as ComunidadesSlugAdminRouteImport } from './routes/comunidades.$slug.admin'
import { Route as ComunidadesSlugChatRouteImport } from './routes/comunidades.$slug.chat'
import { Route as ComunidadesConviteTokenRouteImport } from './routes/comunidades.convite.$token'
import { Route as MiniSiteTemplatesIndexRouteImport } from './routes/mini-site.templates.index'
import { Route as MiniSiteTemplatesIdRouteImport } from './routes/mini-site.templates.$id'
import { Route as SettingsBillingDiagnosticsRouteImport } from './routes/settings.billing.diagnostics'
import { Route as ComunidadesSlugTopicoIdRouteImport } from './routes/comunidades.$slug.topico.$id'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const UsernameRoute = UsernameRouteImport.update({
            id: '/$username',path: '/$username',getParentRoute: () => rootRouteImport
          })
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
            id: '/_authenticated',getParentRoute: () => rootRouteImport
          })
const AlternativaAoDiscogsRoute = AlternativaAoDiscogsRouteImport.update({
            id: '/alternativa-ao-discogs',path: '/alternativa-ao-discogs',getParentRoute: () => rootRouteImport
          })
const AssinarRoute = AssinarRouteImport.update({
            id: '/assinar',path: '/assinar',getParentRoute: () => rootRouteImport
          })
const AuthRoute = AuthRouteImport.update({
            id: '/auth',path: '/auth',getParentRoute: () => rootRouteImport
          })
const ChatRoute = ChatRouteImport.update({
            id: '/chat',path: '/chat',getParentRoute: () => rootRouteImport
          })
const ColecionadoresRoute = ColecionadoresRouteImport.update({
            id: '/colecionadores',path: '/colecionadores',getParentRoute: () => rootRouteImport
          })
const CollectionRoute = CollectionRouteImport.update({
            id: '/collection',path: '/collection',getParentRoute: () => rootRouteImport
          })
const ComunidadeRoute = ComunidadeRouteImport.update({
            id: '/comunidade',path: '/comunidade',getParentRoute: () => rootRouteImport
          })
const ConquistasRoute = ConquistasRouteImport.update({
            id: '/conquistas',path: '/conquistas',getParentRoute: () => rootRouteImport
          })
const ContatoRoute = ContatoRouteImport.update({
            id: '/contato',path: '/contato',getParentRoute: () => rootRouteImport
          })
const ConvidarRoute = ConvidarRouteImport.update({
            id: '/convidar',path: '/convidar',getParentRoute: () => rootRouteImport
          })
const ExploreRoute = ExploreRouteImport.update({
            id: '/explore',path: '/explore',getParentRoute: () => rootRouteImport
          })
const FeedRoute = FeedRouteImport.update({
            id: '/feed',path: '/feed',getParentRoute: () => rootRouteImport
          })
const GarimpoRoute = GarimpoRouteImport.update({
            id: '/garimpo',path: '/garimpo',getParentRoute: () => rootRouteImport
          })
const InsightsRoute = InsightsRouteImport.update({
            id: '/insights',path: '/insights',getParentRoute: () => rootRouteImport
          })
const LabRoute = LabRouteImport.update({
            id: '/lab',path: '/lab',getParentRoute: () => rootRouteImport
          })
const LevelsRoute = LevelsRouteImport.update({
            id: '/levels',path: '/levels',getParentRoute: () => rootRouteImport
          })
const MarketplaceRoute = MarketplaceRouteImport.update({
            id: '/marketplace',path: '/marketplace',getParentRoute: () => rootRouteImport
          })
const MeRoute = MeRouteImport.update({
            id: '/me',path: '/me',getParentRoute: () => rootRouteImport
          })
const MiniSiteRoute = MiniSiteRouteImport.update({
            id: '/mini-site',path: '/mini-site',getParentRoute: () => rootRouteImport
          })
const PoliticaDeReembolsoRoute = PoliticaDeReembolsoRouteImport.update({
            id: '/politica-de-reembolso',path: '/politica-de-reembolso',getParentRoute: () => rootRouteImport
          })
const PrivacidadeRoute = PrivacidadeRouteImport.update({
            id: '/privacidade',path: '/privacidade',getParentRoute: () => rootRouteImport
          })
const ResetPasswordRoute = ResetPasswordRouteImport.update({
            id: '/reset-password',path: '/reset-password',getParentRoute: () => rootRouteImport
          })
const RitualRoute = RitualRouteImport.update({
            id: '/ritual',path: '/ritual',getParentRoute: () => rootRouteImport
          })
const SearchRoute = SearchRouteImport.update({
            id: '/search',path: '/search',getParentRoute: () => rootRouteImport
          })
const SemanalRoute = SemanalRouteImport.update({
            id: '/semanal',path: '/semanal',getParentRoute: () => rootRouteImport
          })
const SettingsRoute = SettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => rootRouteImport
          })
const SobreNosRoute = SobreNosRouteImport.update({
            id: '/sobre-nos',path: '/sobre-nos',getParentRoute: () => rootRouteImport
          })
const StreaksRoute = StreaksRouteImport.update({
            id: '/streaks',path: '/streaks',getParentRoute: () => rootRouteImport
          })
const TermosDeServicoRoute = TermosDeServicoRouteImport.update({
            id: '/termos-de-servico',path: '/termos-de-servico',getParentRoute: () => rootRouteImport
          })
const UnsubscribeRoute = UnsubscribeRouteImport.update({
            id: '/unsubscribe',path: '/unsubscribe',getParentRoute: () => rootRouteImport
          })
const WishlistRoute = WishlistRouteImport.update({
            id: '/wishlist',path: '/wishlist',getParentRoute: () => rootRouteImport
          })
const AuthenticatedOnboardingRoute = AuthenticatedOnboardingRouteImport.update({
            id: '/onboarding',path: '/onboarding',getParentRoute: () => AuthenticatedRouteRoute
          })
const AlbumIdRoute = AlbumIdRouteImport.update({
            id: '/album/$id',path: '/album/$id',getParentRoute: () => rootRouteImport
          })
const ArtistasIndexRoute = ArtistasIndexRouteImport.update({
            id: '/artistas/',path: '/artistas/',getParentRoute: () => rootRouteImport
          })
const ArtistasSlugRoute = ArtistasSlugRouteImport.update({
            id: '/artistas/$slug',path: '/artistas/$slug',getParentRoute: () => rootRouteImport
          })
const BlogIndexRoute = BlogIndexRouteImport.update({
            id: '/blog/',path: '/blog/',getParentRoute: () => rootRouteImport
          })
const BlogSlugRoute = BlogSlugRouteImport.update({
            id: '/blog/$slug',path: '/blog/$slug',getParentRoute: () => rootRouteImport
          })
const ComunidadesIndexRoute = ComunidadesIndexRouteImport.update({
            id: '/comunidades/',path: '/comunidades/',getParentRoute: () => rootRouteImport
          })
const ComunidadesNovoRoute = ComunidadesNovoRouteImport.update({
            id: '/comunidades/novo',path: '/comunidades/novo',getParentRoute: () => rootRouteImport
          })
const DiscosDeVinilIndexRoute = DiscosDeVinilIndexRouteImport.update({
            id: '/discos-de-vinil/',path: '/discos-de-vinil/',getParentRoute: () => rootRouteImport
          })
const DiscosDeVinilSlugRoute = DiscosDeVinilSlugRouteImport.update({
            id: '/discos-de-vinil/$slug',path: '/discos-de-vinil/$slug',getParentRoute: () => rootRouteImport
          })
const GruposIndexRoute = GruposIndexRouteImport.update({
            id: '/grupos/',path: '/grupos/',getParentRoute: () => rootRouteImport
          })
const GruposSplatRoute = GruposSplatRouteImport.update({
            id: '/grupos/$',path: '/grupos/$',getParentRoute: () => rootRouteImport
          })
const GuiasIndexRoute = GuiasIndexRouteImport.update({
            id: '/guias/',path: '/guias/',getParentRoute: () => rootRouteImport
          })
const GuiasSlugRoute = GuiasSlugRouteImport.update({
            id: '/guias/$slug',path: '/guias/$slug',getParentRoute: () => rootRouteImport
          })
const LabIndexRoute = LabIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => LabRoute
          })
const LabIdRoute = LabIdRouteImport.update({
            id: '/$id',path: '/$id',getParentRoute: () => LabRoute
          })
const LabRoadmapRoute = LabRoadmapRouteImport.update({
            id: '/roadmap',path: '/roadmap',getParentRoute: () => LabRoute
          })
const MiniSiteIndexRoute = MiniSiteIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => MiniSiteRoute
          })
const PCodeRoute = PCodeRouteImport.update({
            id: '/p/$code',path: '/p/$code',getParentRoute: () => rootRouteImport
          })
const ProductsSplatRoute = ProductsSplatRouteImport.update({
            id: '/products/$',path: '/products/$',getParentRoute: () => rootRouteImport
          })
const ProfileUsernameRoute = ProfileUsernameRouteImport.update({
            id: '/profile/$username',path: '/profile/$username',getParentRoute: () => rootRouteImport
          })
const SettingsIndexRoute = SettingsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => SettingsRoute
          })
const SettingsAccountRoute = SettingsAccountRouteImport.update({
            id: '/account',path: '/account',getParentRoute: () => SettingsRoute
          })
const SettingsBillingRoute = SettingsBillingRouteImport.update({
            id: '/billing',path: '/billing',getParentRoute: () => SettingsRoute
          })
const SettingsNotificationsRoute = SettingsNotificationsRouteImport.update({
            id: '/notifications',path: '/notifications',getParentRoute: () => SettingsRoute
          })
const SettingsPerformanceRoute = SettingsPerformanceRouteImport.update({
            id: '/performance',path: '/performance',getParentRoute: () => SettingsRoute
          })
const SettingsProfileRoute = SettingsProfileRouteImport.update({
            id: '/profile',path: '/profile',getParentRoute: () => SettingsRoute
          })
const DotlovableOauthConsentRoute = DotlovableOauthConsentRouteImport.update({
            id: '/.lovable/oauth/consent',path: '/.lovable/oauth/consent',getParentRoute: () => rootRouteImport
          })
const AuthenticatedAdminBlogRoute = AuthenticatedAdminBlogRouteImport.update({
            id: '/admin/blog',path: '/admin/blog',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAdminCrmRoute = AuthenticatedAdminCrmRouteImport.update({
            id: '/admin/crm',path: '/admin/crm',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAdminEmailsRoute = AuthenticatedAdminEmailsRouteImport.update({
            id: '/admin/emails',path: '/admin/emails',getParentRoute: () => AuthenticatedRouteRoute
          })
const ComunidadesSlugIndexRoute = ComunidadesSlugIndexRouteImport.update({
            id: '/comunidades/$slug/',path: '/comunidades/$slug/',getParentRoute: () => rootRouteImport
          })
const ComunidadesSlugAdminRoute = ComunidadesSlugAdminRouteImport.update({
            id: '/comunidades/$slug/admin',path: '/comunidades/$slug/admin',getParentRoute: () => rootRouteImport
          })
const ComunidadesSlugChatRoute = ComunidadesSlugChatRouteImport.update({
            id: '/comunidades/$slug/chat',path: '/comunidades/$slug/chat',getParentRoute: () => rootRouteImport
          })
const ComunidadesConviteTokenRoute = ComunidadesConviteTokenRouteImport.update({
            id: '/comunidades/convite/$token',path: '/comunidades/convite/$token',getParentRoute: () => rootRouteImport
          })
const MiniSiteTemplatesIndexRoute = MiniSiteTemplatesIndexRouteImport.update({
            id: '/templates/',path: '/templates/',getParentRoute: () => MiniSiteRoute
          })
const MiniSiteTemplatesIdRoute = MiniSiteTemplatesIdRouteImport.update({
            id: '/templates/$id',path: '/templates/$id',getParentRoute: () => MiniSiteRoute
          })
const SettingsBillingDiagnosticsRoute = SettingsBillingDiagnosticsRouteImport.update({
            id: '/diagnostics',path: '/diagnostics',getParentRoute: () => SettingsBillingRoute
          })
const ComunidadesSlugTopicoIdRoute = ComunidadesSlugTopicoIdRouteImport.update({
            id: '/comunidades/$slug/topico/$id',path: '/comunidades/$slug/topico/$id',getParentRoute: () => rootRouteImport
          })





const AuthenticatedRouteRouteChildren = {
  AuthenticatedOnboardingRoute: AuthenticatedOnboardingRoute,AuthenticatedAdminBlogRoute: AuthenticatedAdminBlogRoute,AuthenticatedAdminCrmRoute: AuthenticatedAdminCrmRoute,AuthenticatedAdminEmailsRoute: AuthenticatedAdminEmailsRoute
}

const AuthenticatedRouteRouteWithChildren = AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)




const LabRouteChildren = {
  LabIdRoute: LabIdRoute,LabRoadmapRoute: LabRoadmapRoute,LabIndexRoute: LabIndexRoute
}

const LabRouteWithChildren = LabRoute._addFileChildren(LabRouteChildren)




const MiniSiteRouteChildren = {
  MiniSiteIndexRoute: MiniSiteIndexRoute,MiniSiteTemplatesIdRoute: MiniSiteTemplatesIdRoute,MiniSiteTemplatesIndexRoute: MiniSiteTemplatesIndexRoute
}

const MiniSiteRouteWithChildren = MiniSiteRoute._addFileChildren(MiniSiteRouteChildren)




const SettingsBillingRouteChildren = {
  SettingsBillingDiagnosticsRoute: SettingsBillingDiagnosticsRoute
}

const SettingsBillingRouteWithChildren = SettingsBillingRoute._addFileChildren(SettingsBillingRouteChildren)



const SettingsRouteChildren = {
  SettingsAccountRoute: SettingsAccountRoute,SettingsBillingRoute: SettingsBillingRouteWithChildren,SettingsNotificationsRoute: SettingsNotificationsRoute,SettingsPerformanceRoute: SettingsPerformanceRoute,SettingsProfileRoute: SettingsProfileRoute,SettingsIndexRoute: SettingsIndexRoute
}

const SettingsRouteWithChildren = SettingsRoute._addFileChildren(SettingsRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,UsernameRoute: UsernameRoute,AlternativaAoDiscogsRoute: AlternativaAoDiscogsRoute,AssinarRoute: AssinarRoute,AuthRoute: AuthRoute,ChatRoute: ChatRoute,ColecionadoresRoute: ColecionadoresRoute,CollectionRoute: CollectionRoute,ComunidadeRoute: ComunidadeRoute,ConquistasRoute: ConquistasRoute,ContatoRoute: ContatoRoute,ConvidarRoute: ConvidarRoute,ExploreRoute: ExploreRoute,FeedRoute: FeedRoute,GarimpoRoute: GarimpoRoute,InsightsRoute: InsightsRoute,LabRoute: LabRouteWithChildren,LevelsRoute: LevelsRoute,MarketplaceRoute: MarketplaceRoute,MeRoute: MeRoute,MiniSiteRoute: MiniSiteRouteWithChildren,PoliticaDeReembolsoRoute: PoliticaDeReembolsoRoute,PrivacidadeRoute: PrivacidadeRoute,ResetPasswordRoute: ResetPasswordRoute,RitualRoute: RitualRoute,SearchRoute: SearchRoute,SemanalRoute: SemanalRoute,SettingsRoute: SettingsRouteWithChildren,SobreNosRoute: SobreNosRoute,StreaksRoute: StreaksRoute,TermosDeServicoRoute: TermosDeServicoRoute,UnsubscribeRoute: UnsubscribeRoute,WishlistRoute: WishlistRoute,AlbumIdRoute: AlbumIdRoute,ArtistasSlugRoute: ArtistasSlugRoute,BlogSlugRoute: BlogSlugRoute,ComunidadesNovoRoute: ComunidadesNovoRoute,DiscosDeVinilSlugRoute: DiscosDeVinilSlugRoute,GruposSplatRoute: GruposSplatRoute,GuiasSlugRoute: GuiasSlugRoute,PCodeRoute: PCodeRoute,ProductsSplatRoute: ProductsSplatRoute,ProfileUsernameRoute: ProfileUsernameRoute,ArtistasIndexRoute: ArtistasIndexRoute,BlogIndexRoute: BlogIndexRoute,ComunidadesIndexRoute: ComunidadesIndexRoute,DiscosDeVinilIndexRoute: DiscosDeVinilIndexRoute,GruposIndexRoute: GruposIndexRoute,GuiasIndexRoute: GuiasIndexRoute,DotlovableOauthConsentRoute: DotlovableOauthConsentRoute,ComunidadesSlugAdminRoute: ComunidadesSlugAdminRoute,ComunidadesSlugChatRoute: ComunidadesSlugChatRoute,ComunidadesConviteTokenRoute: ComunidadesConviteTokenRoute,ComunidadesSlugIndexRoute: ComunidadesSlugIndexRoute,ComunidadesSlugTopicoIdRoute: ComunidadesSlugTopicoIdRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)